import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { SubscriptionPlan } from '../models/subscriptionPlan';
import { iHttpPaginatedResponse } from '../interfaces/iHttpPaginatedResponse';

@Injectable({
  providedIn: 'root'
})

export class SearchService {

    constructor(private http: HttpClient) {
    }

    public courseSearch(terms, page): Observable<iHttpPaginatedResponse> {
        return this.http.post<iHttpPaginatedResponse>(environment.apiEndpoint + `/api/search/course?page=${page}&all=all`,{terms:terms}).pipe(
            map(res => {
                return res;
            })
        );
    }

    public streamSearch(terms, page): Observable<iHttpPaginatedResponse>
    {
      return this.http.post<iHttpPaginatedResponse>(environment.apiEndpoint + `/api/search/stream?page=${page}&all=all`, {
        terms: terms
      }).pipe(
        map(
          res=>{
            return res;
          }
        )
      );
    }
}
